module.exports = __webpack_public_path__ + "img/icon6.adc060cc.svg";